export enum NavItemLinkOptions {
  PageIntern = 'pageintern',
  PageExtern = 'pageextern',
  PageAnchor = 'pageanchor',
}
